import { BrowserRouter, Navigate, Outlet, Route, Routes } from 'react-router-dom'

import { PageNotFound } from '@reveni-io/reveni-ui'

import BillingDetailPage from '../billing/pages/BillingDetailPage/BillingDetailPage'
import BillingPage from '../billing/pages/BillingPage/BillingPage'
import PageLayout from '../common/components/PageLayout'
import ConfigurationPage from '../configuration/pages/ConfigurationPage'
import BillingConfiguration from '../configuration/pages/ConfigurationPage/BillingConfiguration/BillingConfiguration'
import CommunicationsGeneralConfiguration from '../configuration/pages/ConfigurationPage/CommunicationsConfiguration/CommunicationsGeneralConfiguration/CommunicationsGeneralConfiguration'
import EmailTemplateDetailConfiguration from '../configuration/pages/ConfigurationPage/CommunicationsConfiguration/EmailTemplates/EmailTemplateDetailConfiguration/EmailTemplateDetailConfiguration'
import EmailTemplatesConfiguration from '../configuration/pages/ConfigurationPage/CommunicationsConfiguration/EmailTemplates/EmailTemplatesConfiguration/EmailTemplatesConfiguration'
import ThemesConfiguration from '../configuration/pages/ConfigurationPage/CommunicationsConfiguration/ThemesConfiguration/ThemesConfiguration'
import BracketingWidgetConfigurationPage from '../configuration/pages/ConfigurationPage/ExtrasConfiguration/BracketingWidgetConfigurationPage/BracketingWidgetConfigurationPage'
import ReveniWidgetConfigurationPage from '../configuration/pages/ConfigurationPage/ExtrasConfiguration/ReveniWidgetConfigurationPage/ReveniWidgetConfigurationPage'
import ShippingWidgetConfigurationPage from '../configuration/pages/ConfigurationPage/ExtrasConfiguration/ShippingWidgetConfigurationPage/ShippingWidgetConfigurationPage'
import SizingWidgetConfigurationPage from '../configuration/pages/ConfigurationPage/ExtrasConfiguration/SizingWidgetConfigurationPage/SizingWidgetConfigurationPage'
import TopBannerWidgetConfigurationPage from '../configuration/pages/ConfigurationPage/ExtrasConfiguration/TopBannerWidgetConfigurationPage/TopBannerWidgetConfigurationPage'
import TryOnWidgetConfigurationPage from '../configuration/pages/ConfigurationPage/ExtrasConfiguration/TryOnWidgetConfigurationPage/TryOnWidgetConfigurationPage'
import IntegrationsConfigurations from '../configuration/pages/ConfigurationPage/IntegrationsConfigurations/IntegrationsConfigurations'
import IntegrationsDetailConfiguration from '../configuration/pages/ConfigurationPage/IntegrationsConfigurations/IntegrationsDetailConfiguration/IntegrationsDetailConfiguration'
import InventoryConfiguration from '../configuration/pages/ConfigurationPage/InventoryConfiguration/InventoryConfiguration'
import AvailabilityCriterionDetailConfiguration from '../configuration/pages/ConfigurationPage/LogisticsConfiguration/DeliveryMethods/AvailabilityCriterionDetailConfiguration/AvailabilityCriterionDetailConfiguration'
import DeliveryMethodDetailConfiguration from '../configuration/pages/ConfigurationPage/LogisticsConfiguration/DeliveryMethods/DeliveryMethodDetailConfiguration/DeliveryMethodDetailConfiguration'
import DeliveryMethodsConfiguration from '../configuration/pages/ConfigurationPage/LogisticsConfiguration/DeliveryMethods/DeliveryMethodsConfiguration/DeliveryMethodsConfiguration'
import GeneralConfiguration from '../configuration/pages/ConfigurationPage/LogisticsConfiguration/GeneralConfiguration/GeneralConfiguration'
import LocationDetailConfiguration from '../configuration/pages/ConfigurationPage/LogisticsConfiguration/Locations/LocationDetailConfiguration/LocationDetailConfiguration'
import LocationsConfiguration from '../configuration/pages/ConfigurationPage/LogisticsConfiguration/Locations/LocationsConfiguration/LocationsConfiguration'
import PackagingConfiguration from '../configuration/pages/ConfigurationPage/LogisticsConfiguration/Packaging/PackagingConfiguration/PackagingConfiguration'
import PackagingDetailConfiguration from '../configuration/pages/ConfigurationPage/LogisticsConfiguration/Packaging/PackagingDetailConfiguration/PackagingDetailConfiguration'
import ReturnInstructionDetailConfiguration from '../configuration/pages/ConfigurationPage/LogisticsConfiguration/ReturnInstructions/ReturnInstructionDetailConfiguration/ReturnInstructionDetailConfiguration'
import ReturnInstructionsConfiguration from '../configuration/pages/ConfigurationPage/LogisticsConfiguration/ReturnInstructions/ReturnInstructionsConfiguration/ReturnInstructionsConfiguration'
import ShippingAvailabilityCriterionDetailConfiguration from '../configuration/pages/ConfigurationPage/LogisticsConfiguration/ShippingMethods/ShippingAvailabilityCriterionDetailConfiguration/ShippingAvailabilityCriterionDetailConfiguration'
import ShippingMethodsConfiguration from '../configuration/pages/ConfigurationPage/LogisticsConfiguration/ShippingMethods/ShippingMethodsConfiguration/ShippingMethodsConfiguration'
import ShippingMethodsDetailConfiguration from '../configuration/pages/ConfigurationPage/LogisticsConfiguration/ShippingMethods/ShippingMethodsDetailConfiguration/ShippingMethodsDetailConfiguration'
import OrderTrackingPageConfiguration from '../configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/OrderTrackingPageConfiguration'
import VisibilityCriterionDetailConfiguration from '../configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/VisibilityCriterionDetailConfiguration/VisibilityCriterionDetailConfiguration'
import RefundsConfiguration from '../configuration/pages/ConfigurationPage/RefundsConfiguration/RefundsConfiguration'
import ExceptionDetailConfiguration from '../configuration/pages/ConfigurationPage/ReturnPolicy/ExceptionsConfiguration/ExceptionDetailConfiguration/ExceptionDetailConfiguration'
import ExceptionsList from '../configuration/pages/ConfigurationPage/ReturnPolicy/ExceptionsConfiguration/ExceptionsList/ExceptionsList'
import PolicyRuleDetailConfiguration from '../configuration/pages/ConfigurationPage/ReturnPolicy/PolicyRulesConfiguration/PolicyRuleDetailConfiguration/PolicyRuleDetailConfiguration'
import PolicyRulesList from '../configuration/pages/ConfigurationPage/ReturnPolicy/PolicyRulesConfiguration/PolicyRulesList/PolicyRulesList'
import ReturnPolicyConfiguration from '../configuration/pages/ConfigurationPage/ReturnPolicy/ReturnPolicyConfiguration/ReturnPolicyConfiguration'
import ReturnProtectionAppearanceConfiguration from '../configuration/pages/ConfigurationPage/ReturnProtectionConfiguration/ReturnProtectionAppearanceConfiguration/ReturnProtectionAppearanceConfiguration'
import ReturnProtectionGeneralConfiguration from '../configuration/pages/ConfigurationPage/ReturnProtectionConfiguration/ReturnProtectionGeneralConfiguration/ReturnProtectionGeneralConfiguration'
import ReturnReasonDetailConfiguration from '../configuration/pages/ConfigurationPage/ReturnReasonsConfiguration/ReturnReasonDetailConfiguration/ReturnReasonDetailConfiguration'
import ReturnReasonsConfiguration from '../configuration/pages/ConfigurationPage/ReturnReasonsConfiguration/ReturnReasonsConfiguration'
import ReturnReasonsSettingsConfiguration from '../configuration/pages/ConfigurationPage/ReturnReasonsConfiguration/ReturnReasonsSettingsConfiguration/ReturnReasonsSettingsConfiguration'
import ReturnsPortalConfigurationPage from '../configuration/pages/ConfigurationPage/ReturnsPortalConfiguration/ReturnsPortalConfigurationPage/ReturnsPortalConfigurationPage'
import ReturnsPortalCopiesPage from '../configuration/pages/ConfigurationPage/ReturnsPortalConfiguration/ReturnsPortalCopiesPage/ReturnsPortalCopiesPage'
import StoreConfiguration from '../configuration/pages/ConfigurationPage/StoreConfiguration/StoreConfiguration'
import ThemeConfiguration from '../configuration/pages/ConfigurationPage/ThemeConfiguration/ThemeConfiguration'
import GroupDetailConfiguration from '../configuration/pages/ConfigurationPage/UsersConfiguration/GroupDetailConfiguration/GroupDetailConfiguration'
import UserDetailConfiguration from '../configuration/pages/ConfigurationPage/UsersConfiguration/UserDetailConfiguration/UserDetailConfiguration'
import UsersConfiguration from '../configuration/pages/ConfigurationPage/UsersConfiguration/UsersConfiguration'
import AccountPage from '../general/pages/AccountPage/AccountPage'
import PreferencesConfiguration from '../general/pages/AccountPage/PreferencesConfiguration/PreferencesConfiguration'
import ProfileConfiguration from '../general/pages/AccountPage/ProfileConfiguration/ProfileConfiguration'
import SecurityConfiguration from '../general/pages/AccountPage/SecurityConfiguration/SecurityConfiguration'
import AnalyticsPage from '../general/pages/AnalyticsPage/AnalyticsPage'
import LoginPage from '../general/pages/LoginPage/LoginPage'
import SignupPage from '../general/pages/SignupPage/SignupPage'
import InventoryPage from '../inventory/pages/InventoryPage/InventoryPage'
import CategoryMetricDetailPage from '../metrics/pages/CategoryMetricDetailPage/CategoryMetricDetailPage'
import ProductByCategoryMetricsDetailPage from '../metrics/pages/CategoryMetricDetailPage/ProductByCategoryMetricsDetailPage/ProductByCategoryMetricsDetailPage'
import VariantByCategoryMetricsDetailPage from '../metrics/pages/CategoryMetricDetailPage/VariantByCategoryMetricsDetailPage/VariantByCategoryMetricsDetailPage'
import CollectionMetricDetailPage from '../metrics/pages/CollectionMetricDetailPage/CollectionMetricDetailPage'
import ProductByCollectionMetricsDetailPage from '../metrics/pages/CollectionMetricDetailPage/ProductByCollectionMetricsDetailPage/ProductByCollectionMetricsDetailPage'
import VariantByCollectionMetricsDetailPage from '../metrics/pages/CollectionMetricDetailPage/VariantByCollectionMetricsDetailPage/VariantByCollectionMetricsDetailPage'
import DashboardPage from '../metrics/pages/DashboardPage/DashboardPage'
import PerformanceInsightsPage from '../metrics/pages/PerformanceInsightsPage/PerformanceInsightsPage'
import ProductMetricsDetailPage from '../metrics/pages/ProductMetricsDetailPage/ProductMetricsDetailPage'
import ProductByReasonMetricsDetailPage from '../metrics/pages/ReasonMetricDetailPage/ProductByReasonMetricsDetailPage/ProductByReasonMetricsDetailPage'
import ReasonMetricDetailPage from '../metrics/pages/ReasonMetricDetailPage/ReasonMetricDetailPage'
import SubReasonMetricsDetailPage from '../metrics/pages/ReasonMetricDetailPage/SubReasonMetricsDetailPage/SubReasonMetricsDetailPage'
import ProductByTypeMetricsDetailPage from '../metrics/pages/TypeMetricDetailPage/ProductByTypeMetricsDetailPage/ProductByTypeMetricsDetailPage'
import TypeMetricDetailPage from '../metrics/pages/TypeMetricDetailPage/TypeMetricDetailPage'
import VariantByTypeMetricsDetailPage from '../metrics/pages/TypeMetricDetailPage/VariantByTypeMetricsDetailPage/VariantByTypeMetricsDetailPage'
import VariantMetricsDetailPage from '../metrics/pages/VariantMetricsDetailPage/VariantMetricsDetailPage'
import { parcelDirections } from '../parcels/constants'
import ParcelDetailPage from '../parcels/pages/ParcelDetailPage/ParcelDetailPage'
import ParcelPreparePage from '../parcels/pages/ParcelPreparePage/ParcelPreparePage'
import ParcelsListPage from '../parcels/pages/ParcelsPage/pages/ParcelsListPage/ParcelsListPage'
import ParcelsPage from '../parcels/pages/ParcelsPage/ParcelsPage'
import ParcelSplitPage from '../parcels/pages/ParcelSplitPage/ParcelSplitPage'
import TransactionDetailPage from '../returns/pages/TransactionDetailPage/TransactionDetailPage'
import TransactionIssueRefundPage from '../returns/pages/TransactionIssueRefundPage/TransactionIssueRefundPage'
import TransactionReviewAdditionalProductsPage from '../returns/pages/TransactionReviewAdditionalProductsPage/TransactionReviewAdditionalProductsPage'
import TransactionRMAPage from '../returns/pages/TransactionRMAPage/TransactionRMAPage'
import TransactionsPage from '../returns/pages/TransactionsPage/TransactionsPage'
import TransactionValidationPage from '../returns/pages/TransactionValidationPage/TransactionValidationPage'
import AuthRoute from './AuthRoute/AuthRoute'
import ParcelsRedirect from './ParcelsRedirect/ParcelsRedirect'
import PerformanceInsightsRedirect from './PerformanceInsightsRedirect/PerformanceInsightsRedirect'
import PerformanceInsightsRoute from './PerformanceInsightsRoute/PerformanceInsightsRoute'
import RedirectToUnifiedDashboard from './RedirectToUnifiedDashboard/RedirectToUnifiedDashboard'
import RemoveMeticsFilters from './RemoveMeticsFilters/RemoveMeticsFilters'
import routes from './routes.constants'
import ScrollToTop from './ScrollToTop'

const Router = () => {
  return (
    <BrowserRouter useTransitions={false}>
      <ScrollToTop />
      <RedirectToUnifiedDashboard />
      <RemoveMeticsFilters />
      <ParcelsRedirect />
      <Routes>
        <Route path={routes.loginPage} element={<LoginPage />} />
        <Route path={routes.signupPage} element={<SignupPage />} />
        <Route element={<PageLayout />}>
          <Route
            path={routes.dashboardPage}
            element={
              <AuthRoute>
                <DashboardPage key="home" />
              </AuthRoute>
            }
          />
          <Route
            path={routes.merchantDashboardPage}
            element={
              <AuthRoute>
                <DashboardPage key="merchant-dashboard" isUnifiedDashboard />
              </AuthRoute>
            }
          />
          <Route
            path={routes.merchantTransactionsPage}
            element={
              <AuthRoute>
                <TransactionsPage key="merchant-transactions" isUnifiedDashboard />
              </AuthRoute>
            }
          />
          <Route
            path={routes.transactionsPage}
            element={
              <AuthRoute>
                <TransactionsPage key="transactions" />
              </AuthRoute>
            }
          />
          <Route
            path={routes.transactionDetailPage}
            element={
              <AuthRoute>
                <TransactionDetailPage />
              </AuthRoute>
            }
          />
          <Route
            path={routes.merchantTransactionsTransactionDetailPage}
            element={
              <AuthRoute>
                <TransactionDetailPage isUnifiedDashboard />
              </AuthRoute>
            }
          />
          <Route
            path={routes.transactionValidationPage}
            element={
              <AuthRoute>
                <TransactionValidationPage />
              </AuthRoute>
            }
          />
          <Route
            path={routes.transactionIssueRefund}
            element={
              <AuthRoute>
                <TransactionIssueRefundPage />
              </AuthRoute>
            }
          />
          <Route
            path={routes.transactionReviewAdditionalProducts}
            element={
              <AuthRoute>
                <TransactionReviewAdditionalProductsPage />
              </AuthRoute>
            }
          />
          <Route
            path={routes.transactionRMA}
            element={
              <AuthRoute>
                <TransactionRMAPage />
              </AuthRoute>
            }
          />
          <Route
            path={routes.billingPage}
            element={
              <AuthRoute>
                <BillingPage />
              </AuthRoute>
            }
          />
          <Route
            path={routes.configurationPage.index}
            element={
              <AuthRoute>
                <ConfigurationPage key="configuration" />
              </AuthRoute>
            }
          >
            <Route path={routes.configurationPage.store} element={<StoreConfiguration />} />
            <Route path={routes.configurationPage.branding} element={<ThemeConfiguration />} />
            <Route path={routes.configurationPage.refunds} element={<RefundsConfiguration />} />
            <Route
              path={routes.configurationPage.refundsDetail}
              element={<Navigate to={routes.configurationPage.refunds} replace />}
            />
            <Route path={routes.configurationPage.returnPolicy.config} element={<ReturnPolicyConfiguration />} />
            <Route path={routes.configurationPage.returnPolicy.exceptions} element={<ExceptionsList />} />
            <Route
              path={routes.configurationPage.returnPolicy.exceptionDetail}
              element={<ExceptionDetailConfiguration />}
            />
            <Route path={routes.configurationPage.returnPolicy.policyRules} element={<PolicyRulesList />} />
            <Route
              path={routes.configurationPage.returnPolicy.policyRuleDetail}
              element={<PolicyRuleDetailConfiguration />}
            />
            <Route
              path={routes.configurationPage.logistics.deliveryMethods}
              element={<DeliveryMethodsConfiguration />}
            />
            <Route
              path={routes.configurationPage.logistics.deliveryMethodDetailConfiguration}
              element={<DeliveryMethodDetailConfiguration />}
            />
            <Route
              path={routes.configurationPage.logistics.availabilityCriterionDetail}
              element={<AvailabilityCriterionDetailConfiguration />}
            />
            <Route path={routes.configurationPage.logistics.locations} element={<LocationsConfiguration />} />
            <Route
              path={routes.configurationPage.logistics.locationDetailConfiguration}
              element={<LocationDetailConfiguration />}
            />
            <Route
              path={routes.configurationPage.logistics.returnInstructions}
              element={<ReturnInstructionsConfiguration />}
            />
            <Route
              path={routes.configurationPage.logistics.returnInstructionDetailConfiguration}
              element={<ReturnInstructionDetailConfiguration />}
            />
            <Route path={routes.configurationPage.logistics.packaging} element={<PackagingConfiguration />} />
            <Route
              path={routes.configurationPage.logistics.packagingDetailConfiguration}
              element={<PackagingDetailConfiguration />}
            />
            <Route
              path={routes.configurationPage.logistics.shippingMethods}
              element={<ShippingMethodsConfiguration />}
            />
            <Route
              path={routes.configurationPage.logistics.shippingMethodDetailConfiguration}
              element={<ShippingMethodsDetailConfiguration />}
            />
            <Route
              path={routes.configurationPage.logistics.shippingAvailabilityCriterionDetail}
              element={<ShippingAvailabilityCriterionDetailConfiguration />}
            />
            <Route path={routes.configurationPage.logistics.general} element={<GeneralConfiguration />} />
            <Route
              path={routes.configurationPage.returnProtection.general}
              element={<ReturnProtectionGeneralConfiguration />}
            />
            <Route
              path={routes.configurationPage.returnProtection.appearance}
              element={<ReturnProtectionAppearanceConfiguration />}
            />
            <Route path={routes.configurationPage.returnReasons} element={<ReturnReasonsConfiguration />} />
            <Route path={routes.configurationPage.returnReasonsDetail} element={<ReturnReasonDetailConfiguration />} />
            <Route
              path={routes.configurationPage.returnReasonsSettings}
              element={<ReturnReasonsSettingsConfiguration />}
            />
            <Route path={routes.configurationPage.billing} element={<BillingConfiguration />} />
            <Route path={routes.configurationPage.communications} element={<CommunicationsGeneralConfiguration />} />
            <Route path={routes.configurationPage.emailTemplates} element={<EmailTemplatesConfiguration />} />
            <Route path={routes.configurationPage.emailTemplateDetail} element={<EmailTemplateDetailConfiguration />} />
            <Route path={routes.configurationPage.themes} element={<ThemesConfiguration />} />
            <Route path={routes.configurationPage.users} element={<UsersConfiguration />} />
            <Route path={routes.configurationPage.userDetail} element={<UserDetailConfiguration />} />
            <Route path={routes.configurationPage.groupDetail} element={<GroupDetailConfiguration />} />
            <Route path={routes.configurationPage.integrations} element={<IntegrationsConfigurations />} />
            <Route path={routes.configurationPage.integrationsDetail} element={<IntegrationsDetailConfiguration />} />
            <Route path={routes.configurationPage.inventory} element={<InventoryConfiguration />} />
            <Route
              path={routes.configurationPage.orderTrackingPage.config}
              element={<OrderTrackingPageConfiguration />}
            />
            <Route
              path={routes.configurationPage.orderTrackingPage.visibilityCriterionDetail}
              element={<VisibilityCriterionDetailConfiguration />}
            />
            <Route path={routes.configurationPage.returnsPortal.config} element={<ReturnsPortalConfigurationPage />} />
            <Route path={routes.configurationPage.returnsPortal.copies} element={<ReturnsPortalCopiesPage />} />
            <Route path={routes.configurationPage.extras.reveniWidget} element={<ReveniWidgetConfigurationPage />} />
            <Route
              path={routes.configurationPage.extras.shippingWidget}
              element={<ShippingWidgetConfigurationPage />}
            />
            <Route path={routes.configurationPage.extras.sizingWidget} element={<SizingWidgetConfigurationPage />} />
            <Route
              path={routes.configurationPage.extras.bracketingWidget}
              element={<BracketingWidgetConfigurationPage />}
            />
            <Route
              path={routes.configurationPage.extras.topBannerWidget}
              element={<TopBannerWidgetConfigurationPage />}
            />
            <Route path={routes.configurationPage.extras.tryOnWidget} element={<TryOnWidgetConfigurationPage />} />
          </Route>

          <Route
            path={routes.merchantConfigurationPage.index}
            element={
              <AuthRoute>
                <ConfigurationPage key="merchant-configuration" isUnifiedDashboard />
              </AuthRoute>
            }
          >
            <Route
              path={routes.merchantConfigurationPage.returnPolicy}
              element={<ReturnPolicyConfiguration isUnifiedDashboard />}
            />

            <Route
              path={routes.merchantConfigurationPage.branding}
              element={<ThemeConfiguration isUnifiedDashboard />}
            />
            <Route
              path={routes.merchantConfigurationPage.refunds}
              element={<RefundsConfiguration isUnifiedDashboard />}
            />
            <Route
              path={routes.merchantConfigurationPage.refundsDetail}
              element={<Navigate to={routes.merchantConfigurationPage.refunds} replace />}
            />
            <Route
              path={routes.merchantConfigurationPage.communications}
              element={<CommunicationsGeneralConfiguration isUnifiedDashboard />}
            />
            <Route
              path={routes.merchantConfigurationPage.emailTemplates}
              element={<EmailTemplatesConfiguration isUnifiedDashboard />}
            />
            <Route
              path={routes.merchantConfigurationPage.emailTemplateDetail}
              element={<EmailTemplateDetailConfiguration isUnifiedDashboard />}
            />
            <Route
              path={routes.merchantConfigurationPage.themes}
              element={<ThemesConfiguration isUnifiedDashboard />}
            />
          </Route>
          <Route
            path={routes.analyticsPage}
            element={
              <AuthRoute>
                <AnalyticsPage />
              </AuthRoute>
            }
          />
          <Route
            path={routes.accountPage.index}
            element={
              <AuthRoute>
                <AccountPage />
              </AuthRoute>
            }
          >
            <Route path={routes.accountPage.profile} element={<ProfileConfiguration />} />
            <Route path={routes.accountPage.security} element={<SecurityConfiguration />} />
            <Route path={routes.accountPage.security} element={<SecurityConfiguration />} />
            <Route path={routes.accountPage.preferences} element={<PreferencesConfiguration />} />
          </Route>
          <Route
            path={routes.billingDetailPage}
            element={
              <AuthRoute>
                <BillingDetailPage />
              </AuthRoute>
            }
          />
          <Route path={routes.parcelsPage.index} element={<ParcelsPage />}>
            <Route
              path={routes.parcelsPage.outbound}
              element={<ParcelsListPage direction={parcelDirections.outbound} key={parcelDirections.outbound} />}
            />
            <Route
              path={routes.parcelsPage.inbound}
              element={<ParcelsListPage direction={parcelDirections.inbound} key={parcelDirections.inbound} />}
            />
          </Route>
          <Route
            path={routes.performanceInsights}
            element={
              <AuthRoute>
                <PerformanceInsightsRoute>
                  <Outlet />
                </PerformanceInsightsRoute>
              </AuthRoute>
            }
          >
            <Route index element={<PerformanceInsightsRedirect />} />
            <Route element={<PerformanceInsightsPage />}>
              <Route path={routes.performanceInsightsPage.global} />
              <Route path={routes.performanceInsightsPage.markets} />
              <Route path={routes.performanceInsightsPage.products} />
              <Route path={routes.performanceInsightsPage.logistics} />
            </Route>
          </Route>
          <Route path={routes.parcelDetailPage} element={<ParcelDetailPage />} />
          <Route path={routes.parcelPreparePage} element={<ParcelPreparePage />} />
          <Route path={routes.parcelSplitPage} element={<ParcelSplitPage />} />
          <Route path={routes.productMetricsDetailPage} element={<ProductMetricsDetailPage />} />
          <Route
            path={routes.merchantDashboardProductMetricsDetailPage}
            element={<ProductMetricsDetailPage isUnifiedDashboard />}
          />
          <Route path={routes.productVariantMetricsDetailPage} element={<VariantMetricsDetailPage />} />
          <Route
            path={routes.merchantDashboardProductVariantMetricsDetailPage}
            element={<VariantMetricsDetailPage isUnifiedDashboard />}
          />
          <Route path={routes.variantMetricsDetailPage} element={<VariantMetricsDetailPage />} />
          <Route
            path={routes.merchantDashboardVariantMetricsDetailPage}
            element={<VariantMetricsDetailPage isUnifiedDashboard />}
          />
          <Route path={routes.reasonMetricsDetailPage} element={<ReasonMetricDetailPage />} />
          <Route
            path={routes.merchantDashboardReasonMetricsDetailPage}
            element={<ReasonMetricDetailPage isUnifiedDashboard />}
          />
          <Route path={routes.productByReasonMetricsDetailPage} element={<ProductByReasonMetricsDetailPage />} />
          <Route
            path={routes.merchantDashboardProductByReasonMetricsDetailPage}
            element={<ProductByReasonMetricsDetailPage isUnifiedDashboard />}
          />
          <Route path={routes.categoryMetricsDetailPage} element={<CategoryMetricDetailPage />} />
          <Route
            path={routes.merchantDashboardCategoryMetricsDetailPage}
            element={<CategoryMetricDetailPage isUnifiedDashboard />}
          />
          <Route path={routes.productByCategoryMetricsDetailPage} element={<ProductByCategoryMetricsDetailPage />} />
          <Route
            path={routes.merchantDashboardProductByCategoryMetricsDetailPage}
            element={<ProductByCategoryMetricsDetailPage isUnifiedDashboard />}
          />
          <Route path={routes.variantByCategoryMetricsDetailPage} element={<VariantByCategoryMetricsDetailPage />} />
          <Route
            path={routes.merchantDashboardVariantByCategoryMetricsDetailPage}
            element={<VariantByCategoryMetricsDetailPage isUnifiedDashboard />}
          />
          <Route path={routes.typeMetricsDetailPage} element={<TypeMetricDetailPage />} />
          <Route
            path={routes.merchantDashboardTypeMetricsDetailPage}
            element={<TypeMetricDetailPage isUnifiedDashboard />}
          />
          <Route path={routes.productByTypeMetricsDetailPage} element={<ProductByTypeMetricsDetailPage />} />
          <Route
            path={routes.merchantDashboardProductByTypeMetricsDetailPage}
            element={<ProductByTypeMetricsDetailPage isUnifiedDashboard />}
          />
          <Route path={routes.variantByTypeMetricsDetailPage} element={<VariantByTypeMetricsDetailPage />} />
          <Route
            path={routes.merchantDashboardVariantByTypeMetricsDetailPage}
            element={<VariantByTypeMetricsDetailPage isUnifiedDashboard />}
          />
          <Route path={routes.collectionMetricsDetailPage} element={<CollectionMetricDetailPage />} />
          <Route
            path={routes.merchantDashboardCollectionMetricsDetailPage}
            element={<CollectionMetricDetailPage isUnifiedDashboard />}
          />
          <Route
            path={routes.variantByCollectionMetricsDetailPage}
            element={<VariantByCollectionMetricsDetailPage />}
          />
          <Route
            path={routes.merchantDashboardVariantByCollectionMetricsDetailPage}
            element={<VariantByCollectionMetricsDetailPage isUnifiedDashboard />}
          />
          <Route
            path={routes.productByCollectionMetricsDetailPage}
            element={<ProductByCollectionMetricsDetailPage />}
          />
          <Route
            path={routes.merchantDashboardProductByCollectionMetricsDetailPage}
            element={<ProductByCollectionMetricsDetailPage isUnifiedDashboard />}
          />
          <Route path={routes.subReasonMetricsDetailPage} element={<SubReasonMetricsDetailPage />} />
          <Route
            path={routes.merchantDashboardSubReasonMetricsDetailPage}
            element={<SubReasonMetricsDetailPage isUnifiedDashboard />}
          />
          <Route path={routes.inventoryPage.index} element={<InventoryPage />} />
        </Route>
        <Route path="*" element={<PageNotFound redirectLink="https://reveni.io" />} />
      </Routes>
    </BrowserRouter>
  )
}

export default Router
